<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card class="elevation-12">
              <v-toolbar dark color="teal">
                <v-toolbar-title>Reset You Password</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <form ref="form">
                  <v-text-field
                    v-model="password"
                    name="password"
                    label="Password"
                    type="password"
                    placeholder="Enter Password"
                    required
                    :rules="[rules.required]"
                  ></v-text-field>

                  <v-text-field
                    v-model="confirmPassword"
                    name="confirmPassword"
                    label="Confirm Password"
                    type="password"
                    placeholder="Enter Password"
                    :rules="[rules.required]"
                    required
                  ></v-text-field>

                  <div class="red--text">{{ error }}</div>
                  <div class="primary--text">
                    {{ message }}
                  </div>
                  <v-btn
                    dark
                    color="teal"
                    class="mr-4"
                    rounded
                    :loading="loading"
                    @click="login()"
                  >
                    Reset
                  </v-btn>
                  <v-btn to="/login" sm text> Go to Login </v-btn>
                  <!-- <router-link to="/login/forgotpassword">
                    Fogot Password
                  </router-link> -->
                </form>
              </v-card-text>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import api from "@/api";
// import ranges from "./ranges.json";
import axios from "axios";

export default {
  name: "LoginForm",
  data: () => ({
    valid: true,
    password: "",
    confirmPassword: "",
    message: "",
    error: "",
    loading: false,
    rules: {
      required: (v) => !!v || "This Field is required",
    },
  }),
  methods: {
    async login() {
      if (this.$refs.form.validate()) {
        try {
          const resettoken = this.$route.query.token;
          //  console.log(resettoken);
          if (!resettoken) {
            this.error = "Your Login Url is Expierd";
          } else if (!this.password || !this.confirmPassword) {
            this.error = "Please Fill all Fields";
          } else if (this.password !== this.confirmPassword) {
            this.error = "Passwords do not match";
          }
          //   return true;

          if (this.password !== this.confirmPassword) {
            this.error = "Your password does not match";
          } else if (this.password && this.confirmPassword && resettoken) {
            //  console.log(resettoken, this.password);
            this.loading = true;
            await axios
              .post("/api/resetpassword" , { 
                token: resettoken,
                password: this.password
              })
              .then((res) => {
                if (res.data.success == true) {
                  this.error = "";
                  this.message = "Password Changed Successfully , Please Login";
                  this.password = "";
                  this.confirmPassword = "";
                  this.loading = false;
                  this.$refs.form.reset();
                  //  this.$router.push("/login");
                  //    router.push({ name: "/" });
                } else {
                  this.error = "Your Token has been Expire";
                  this.email = "";
                  this.loading = false;
                }
                //   console.log(res.data.access_token);
              });
          }
        } catch (error) {
          this.email = "";
          this.password = "";
          this.error = "Please Write Correct Details.";
          this.loading = false;
        }
      }
    },
  },
};
</script>